import ConversationApiUtils from '../utils/api/conversation';

export const UPDATE_ACTIVE_CONVERSATION_ID = 'UPDATE_ACTIVE_CONVERSATION_ID';
export const FETCH_CONVERSATIONS_SENT = 'FETCH_CONVERSATIONS_SENT';
export const FETCH_CONVERSATIONS_SUCCEEDED = 'FETCH_CONVERSATIONS_SUCCEEDED';
export const FETCH_CONVERSATIONS_FAILED = 'FETCH_CONVERSATIONS_FAILED';
export const LOAD_MORE_CONVERSATIONS_SENT = 'LOAD_MORE_CONVERSATIONS_SENT';
export const LOAD_MORE_CONVERSATIONS_SUCCEEDED =
  'LOAD_MORE_CONVERSATIONS_SUCCEEDED';
export const LOAD_MORE_CONVERSATIONS_FAILED = 'LOAD_MORE_CONVERSATIONS_FAILED';

export function updateActiveConversationId(cid) {
  return {
    type: UPDATE_ACTIVE_CONVERSATION_ID,
    payload: {
      conversationId: cid,
    },
  };
}

export function fetchSent() {
  return { type: FETCH_CONVERSATIONS_SENT };
}

export function fetchSucceeded(data) {
  return {
    type: FETCH_CONVERSATIONS_SUCCEEDED,
    payload: data,
  };
}

export function fetchFailed(error) {
  return { type: FETCH_CONVERSATIONS_FAILED };
}

export function fetch(activeConversationId = null) {
  return (dispatch) => {
    dispatch(fetchSent());
    return ConversationApiUtils.fetch(1, activeConversationId).then(
      (data) => dispatch(fetchSucceeded(data)),
      (error) => dispatch(fetchFailed(error)),
    );
  };
}

export function loadMoreSent() {
  return { type: LOAD_MORE_CONVERSATIONS_SENT };
}

export function loadMoreSucceeded(data) {
  return {
    type: LOAD_MORE_CONVERSATIONS_SUCCEEDED,
    payload: data,
  };
}

export function loadMoreFailed(error) {
  return { type: LOAD_MORE_CONVERSATIONS_FAILED };
}

export function loadMore(page) {
  return (dispatch) => {
    dispatch(loadMoreSent());
    return ConversationApiUtils.fetch(page).then(
      (data) => dispatch(loadMoreSucceeded(data)),
      (error) => dispatch(loadMoreFailed(error)),
    );
  };
}
